import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCheckboxComponent from 'webapp/components/form/checkbox';
import ToolTipComponent from 'webapp/components/tool-tip';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import type { BoardShare, ReportScheduleSetting } from 'webapp/models-custom';

interface Args {
	// Only the boards share form renders this block, so the model is always a
	// BoardShare here; the union matches how the parent passes its model down.
	model: BoardShare | ReportScheduleSetting;
	submitInProgress: boolean;
}

export default class BoardsShareScheduleShareableLinkComponent extends Component<Args> {
	// `includeLink` / `target` live on BoardShare only.
	private get boardShareModel(): BoardShare {
		return this.args.model as BoardShare;
	}

	get disabledShareableLink() {
		const target = this.boardShareModel.target;
		return target && !target.isPublicEnabled;
	}

	get disabledShareableLinkCheckbox() {
		return this.disabledShareableLink || this.args.submitInProgress;
	}

	@action
	changeIncludeLink(includeLink: boolean) {
		this.boardShareModel.includeLink = includeLink;
	}

	<template>
		<div class="has-shareable-link {{if this.disabledShareableLink 'disabled'}}">
			<FormCheckboxComponent
				@name="includeLink"
				@selected={{this.boardShareModel.includeLink}}
				@label="Shareable link"
				@isDisabled={{this.disabledShareableLinkCheckbox}}
				@onChange={{this.changeIncludeLink}}
			/>
			<ToolTipWithIconComponent
				@text="The shareable link provides view only access to your dashboard(s)."
				@position="top"
				@maxWidth={{230}}
			/>
			{{#if this.disabledShareableLink}}
				<ToolTipComponent
					@text="To include this link, turn on the <strong>public link</strong> on the 'Shareable link' tab. Anyone with the link will be able to view shared dashboard(s)."
					@position="top"
					@maxWidth={{230}}
				/>
			{{/if}}
		</div>
	</template>
}
